"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandingDiv = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_spring_1 = require("react-spring");
const lib_1 = require("../../lib");
const ExpandingDiv = ({ children, className, expanded, maxHeight = '500px', config = react_spring_1.config.default }) => {
    const [props, set] = (0, react_spring_1.useSpring)(() => ({
        maxHeight: '0px',
        opacity: 0,
        config
    }));
    (0, react_1.useEffect)(() => {
        if (expanded) {
            set({ opacity: 1, maxHeight });
        }
        else {
            set({ opacity: 0, maxHeight: '0px' });
        }
    }, [expanded]);
    return ((0, jsx_runtime_1.jsx)(react_spring_1.animated.div, Object.assign({ style: props, className: (0, lib_1.classnames)('expanding-div', className) }, { children: children }), void 0));
};
exports.ExpandingDiv = ExpandingDiv;
//# sourceMappingURL=ExpandingDiv.js.map